import { render, staticRenderFns } from "./FindTherapist.vue?vue&type=template&id=18db8dca&"
import script from "./FindTherapist.vue?vue&type=script&lang=js&"
export * from "./FindTherapist.vue?vue&type=script&lang=js&"
import style0 from "./FindTherapist.vue?vue&type=style&index=0&id=18db8dca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports